// extracted by mini-css-extract-plugin
module.exports = {"question":"style_question__2TRmc","header":"style_header__F4lTd"};